export const getters = {
  getLayers: state => {
    return state.layers
  },
  getDates: state => {
    return state.dates
  },
  getSelectedRange: state => {
    return state.selectedRange
  },
  // New organization layers getters
  getOrgLayers: state => (orgId) => {
    return state.orgLayers[orgId] || []
  },
  getOrgLayerById: state => (orgId, layerId) => {
    const orgLayers = state.orgLayers[orgId] || []
    return orgLayers.find(layer => layer.uuid === layerId)
  },
  getSelectedFeature: state => {
    return state.selectedFeature
  }
}
